<template>
  <div class="createMusicScore">
    <van-form>
      <div class="userPhone">
        <div class="title">写下您想要的曲目 我们将会在近期更新</div>
        <div class="number">
          <van-field
            v-model="name"
            required
            type="text"
            label="曲目名称"
            placeholder=""
          >
          </van-field>
        </div>
        <div>
          <SlideVerify
            :l="42"
            :r="10"
            :w="345"
            :h="155"
            ref="slideBlock"
            @again="onAgain"
            @fulfilled="onFulfilled"
            @success="onSuccess"
            @fail="onFail"
            @refresh="onRefresh"
            :slider-text="text"
            :accuracy="accuracy"
            :imgs="imgs"
          ></SlideVerify>
        </div>
      </div>

      <div class="button">
        <van-button round block type="info" :disabled="!isValid" @click="onSubmit">提交</van-button>
      </div>
    </van-form>

    <van-overlay :show="submitLoading">
      <div
        style="
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Form, Field, Button, Radio, Toast, Overlay, Loading } from "vant";
import { addFeedback } from "@/api/activity.js";
import backgroundImage from "@/assets/activity_coupon1.png"; //  如果使用网络图片资源就无需引入

export default {
  name: "createMusicScore",
  components: {
    vanForm: Form,
    vanField: Field,
    vanButton: Button,
    vanRadio: Radio,
    vanOverlay: Overlay,
    vanLoading: Loading,
  },
  data() {
    return {
      name: "",
      submitLoading: false,
      text: "向右滑动验证->", // 设置滑块文字
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 2,
      imgs: [backgroundImage],
      isValid:false,
    };
  },
  mounted() {
    this.requestGetIsShowMore();
  },
  methods: {
    requestGetIsShowMore() {
      GetIsShowMore({ uid: this.uid }).then((res) => {
        if (res.code === 200) {
          this.isMoreShow = res.data;
        }
      });
    },
    onSubmit() {
      if (this.submitLoading) return;

      if (!this.name) {
        Toast("请填写想要的曲目");
        return;
      }

      let params = {
        title: this.name,
      };

      this.submitLoading = true;
      addFeedback(params)
        .then((res) => {
          this.submitLoading = false;
          Toast(res.msg);
          if (res.code === 200) {
            this.name="";
            this.$refs.slideBlock.reset();
          }
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
    onSuccess() {
      this.isValid=true;
    },
    onFail() {
      this.isValid=false;
    },
    // 滑块上的刷新
    onRefresh() {
      
    },
    // 刷新后执行的回调函数
    onFulfilled() {
      
    },
    // 检测是否人为操作
    onAgain() {
     
      this.$refs.slideBlock.reset();
    },
  },
};
</script>

<style lang="scss">
@import "../assets/css/flexable.scss";

.createMusicScore {
  width: 100%;
  padding: 0 20px;
  text-align: left;
  box-sizing: border-box;
  overflow: auto;
  margin-top: 20%;

  .userPhone {
    .title {
      margin-bottom: 20px;
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      color: #1f1f1f;
      text-align: center;
    }
    .number {
      position: relative;
      border-radius: 10px;
      background: #f5f5f9;
      margin-bottom: 20%;
      .van-cell {
        background-color: transparent;
      }
    }
  }
  .button {
    margin-top: 10%;
  }
}
</style>